import { Box } from '@mui/material';
import { useAppConfig } from '../../../../hooks/use-app-config';
import { MdMoreHoriz } from 'react-icons/md';
import "./style.scss";

interface ShowMoreApmProps {
    isSelected: boolean;
    showHiddenApmsList: () => void;
}

export function ShowMoreApms({
    isSelected,
    showHiddenApmsList
}: ShowMoreApmProps) {
    const { theme } = useAppConfig();

    return (
        <Box
            style={{
                borderColor: isSelected ? theme?.button.color : '',
            }}
            className={`payment-method visible more-apms ${isSelected ? 'active' : ''}`}
            onClick={showHiddenApmsList}
        >
            <Box>
                <MdMoreHoriz />
            </Box>
        </Box>
    );
}
